import { headersType } from "../../models";

export const headers: headersType[] = [
  {
    title: "Office Name",
    extraClasses: "w-full lg:w-240 pl-0 truncate",
    sortKey: "name",
    isClickable: true,
  },
  {
    title: "Address",
    extraClasses: "w-full hidden lg:block break-all",
    sortKey: "city",
    isClickable: true,
  },
  {
    title: "Contact",
    extraClasses: "w-full hidden lg:block",
    sortKey: "contactName",
    isClickable: true,
  },
  {
    title: "# Users",
    extraClasses: "w-160 hidden lg:block",
    sortKey: "userState",
    isClickable: false,
  },
  {
    title: "Status",
    extraClasses: "w-160 hidden lg:block",
    sortKey: "userState.name",
    isClickable: false,
  },
];

export const pendingHeaders: headersType[] = [
  {
    title: "Sign up Date",
    extraClasses: "w-full lg:w-240 pl-0 truncate",
    sortKey: "",
    isClickable: true,
  },
  {
    title: "Office name",
    extraClasses: "w-full hidden lg:block break-all",
    sortKey: "",
    isClickable: true,
  },
  {
    title: "Address",
    extraClasses: "w-full hidden lg:block",
    sortKey: "",
    isClickable: true,
  },
  {
    title: "Contact",
    extraClasses: "w-full hidden lg:block",
    sortKey: "",
    isClickable: false,
  },
  {
    title: "Verify",
    extraClasses: "w-full hidden lg:block",
    sortKey: "",
    isClickable: false,
  },
];

export const rejectedHeaders: headersType[] = [
  {
    title: "Rejected Date",
    extraClasses: "w-full lg:w-240 pl-0 truncate",
    sortKey: "",
    isClickable: true,
  },
  {
    title: "Office name",
    extraClasses: "w-full hidden lg:block break-all",
    sortKey: "",
    isClickable: true,
  },
  {
    title: "Contact",
    extraClasses: "w-full hidden lg:block break-all",
    sortKey: "",
    isClickable: false,
  },
  {
    title: "Email",
    extraClasses: "w-full hidden lg:block break-all",
    sortKey: "",
    isClickable: false,
  },
];

export const officeHeaders: headersType[] = [
  {
    title: "Office Name",
    extraClasses: "w-full lg:w-240 pl-0 truncate",
    sortKey: "",
    isClickable: true,
  },
  {
    title: "Address",
    extraClasses: "w-full hidden lg:block break-all",
    sortKey: "",
    isClickable: true,
  },
  {
    title: "Created Date",
    extraClasses: "w-full hidden lg:block break-all",
    sortKey: "",
    isClickable: false,
  },
  {
    title: "Status of Onboarding",
    extraClasses: "w-full hidden lg:block break-all",
    sortKey: "",
    isClickable: false,
  },
  {
    title: "No of Users",
    extraClasses: "w-full hidden lg:block break-all",
    sortKey: "",
    isClickable: false,
  },
  {
    title: "Action",
    extraClasses: "w-full hidden lg:block break-all",
    sortKey: "",
    isClickable: false,
  },
];
